import { RestClient } from '@/api/rest-client'
import { EventLog } from '@/api/model/event-log'

export class EventLogClient extends RestClient<EventLog> {
    collectionName = 'event_logs'
    parseData = EventLog.fromData

    async getAll(): Promise<EventLog[]> {
        try {
            const response = await this.client.get(`${this.basePath}/${this.collectionName}`)
            const collection = response.data['hydra:member'] as any[]
            return collection.map(value => this.parseData(value))

        }  catch (error) {
            this.handleError(error)
        }
    }
}
